
import { Routes, Route } from 'react-router-dom'
import Home from './App'
import S2B from "./s2b"

const AppRouter = () => (
    <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/s2b" element={<S2B />} />

    </Routes>
)

export default AppRouter

